import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import CardEventList from '../CardEventList/CardEventList';
import { getEventi } from '../../services/eventi';
import logoConfH from '../../images/logo confindustria orizz.png';
import sfondoConfH from '../../images/marchio confindustria sfondo.png';
import { ReactComponent as MySVG } from '../../images/mappa e wayfinding.svg';
import EventContainer from '../EventContainer';
import MapDisplay from '../MapDisplay';

const App = () => {
  const currentDate = new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });

  const [eventi, setEventi] = useState([]);
  const [highlightedEvent, setHighlightedEvent] = useState({
    name: '',
    datainizio: '',
    datafine: '',
    status: '',
    description: '',
    logo: '',
    labels: []
  });

  const [highlightedIndex, setHighlightedIndex] = useState(0);

  const svgRef = useRef(null);
  const [triggerNextHighlight, setTriggerNextHighlight] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      getEventi()
        .then(response => {
          console.log('RESPONSE:', response.data);
          const events = response.data.content || [];
          setEventi(events);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    };

    fetchData();

    const intervalId = setInterval(fetchData, 300000);

    return () => clearInterval(intervalId);
}, []);

  useEffect(() => {
    const svgElement = svgRef.current;
    if (svgElement) {
      const percorsoSalaElements = svgElement.querySelectorAll('.percorso_sala');
      percorsoSalaElements.forEach(element => {
        element.style.display = 'none';
      });
    }
  }, [highlightedEvent, eventi]);

  const handleHighlight = (name, datainizio, datafine, status, description, logo, labels) => {
    setHighlightedEvent({ name, datainizio, datafine, status, description, logo, labels });
    setTriggerNextHighlight(false);
  };

  const handleLastLabelHighlight = () => setTriggerNextHighlight(true);

  const handleHighlightedIndexChange = (index) => setHighlightedIndex(index);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath !== '/wayfinding') {
      window.location.pathname = '/wayfinding';
    }
  }, []);

  if (window.location.pathname !== '/wayfinding') {
    return null; // Render nothing while redirecting
  }
  if (eventi.length === 0) {
    return (
        <div className="main-container-nullpage raleway">

          <div className="div2">
            <MySVG ref={svgRef} className="svg-container-nullpage"/>
          </div>

          <div className="div1">
            <div className="centered-container">
              <div className="datenoevent">{currentDate}</div>
              <img src={logoConfH} className="logonoevent" alt="Logo Confindustria"/>
            </div>
          </div>

        </div>
    );
  }

  return (
      <div className="main-container raleway">
        <img src={logoConfH} className="logo" alt="Logo Confindustria" />
      <div className="dataevento">{currentDate}</div>
        <div className="main-content">

          <div className="event-list">
            <CardEventList eventi={eventi} onHighlight={handleHighlight} triggerNextHighlight={triggerNextHighlight} />
          </div>


          <div className="event-card">
            <EventContainer
              eventName={highlightedEvent.name}
              eventdatainizio={highlightedEvent.datainizio}
              eventdatafine={highlightedEvent.datafine}
              eventStatus={highlightedEvent.status}
              eventDescription={highlightedEvent.description}
              eventLogo={highlightedEvent.logo}
              labels={highlightedEvent.labels}
              onLastLabelHighlight={handleLastLabelHighlight}
              onHighlightedIndexChange={handleHighlightedIndexChange}
            />
          </div>
          <div className="map-display">
            <MapDisplay
              currentLabel={highlightedEvent.labels[highlightedIndex]}
            />
          </div>
        </div>
    </div>
  );
};

export default App;
